import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components'
import { VocabProvider, ArgosVocab, HabitatVocab } from '@sainsburys-tech/bolt-vocab-provider'
import { Propbar, ErrorBoundary, Themes } from '@sainsburys-tech/bolt'

import Header from '../components/Header/Header'
import EmailForm from '../components/EmailForm/EmailForm'
import Footer from '../components/Footer/Footer'

import { ScrollPositionProvider } from '../helpers/scrollPositionContext'
import { isHabitatHomepagePath } from '../helpers/pathCheck'
import * as Styled from './MainLayout.styles'

const isHabitat = process.env.BRAND === 'habitat'

const boltClass = isHabitat ? 'habitat' : 'v2'
const theme = isHabitat ? Themes.HabitatTheme : Themes.ArgosTheme
const vocab = isHabitat ? HabitatVocab : ArgosVocab

const MainLayout = ({ children, history }) => {
  const path = history?.location?.pathname

  return (
    <ThemeProvider theme={theme}>
      <VocabProvider vocab={vocab}>
        <ScrollPositionProvider>
          <Styled.AppWrapper data-test='app' className={`bolt-${boltClass}`}>
            {process.env.BRAND !== 'habitat' && (
              <div>
                <Header history={history} />
              </div>
            )}

            <ErrorBoundary>
              <Styled.PropbarContainer>
                <Propbar brand={isHabitat ? 'habitat' : 'argos'} />
              </Styled.PropbarContainer>
            </ErrorBoundary>

            <Styled.AppContent id='app-content' className='container'>
              <main>{children}</main>
            </Styled.AppContent>
            <div>
              {isHabitatHomepagePath(path) && <EmailForm />}
              <Footer brand={isHabitat ? 'habitat' : 'argos'} />
            </div>
          </Styled.AppWrapper>
        </ScrollPositionProvider>
      </VocabProvider>
    </ThemeProvider>
  )
}

MainLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]).isRequired,
  history: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]).isRequired,
}

export default MainLayout
